import React from 'react'
import qs from 'query-string'
import _ from 'lodash'
import TLogin from "../templates/Login/Index"

const Login = ({history, location}) => {
	const search = _.get(location, 'search', '')
	const query = qs.parse(search)
	return (<TLogin redirection={_.get(query, 'redirection', '')}/>)
}

export default Login